import { Dispatch, SetStateAction } from 'react';
import axios from 'axios';

import { Session } from '../../models';
import { getVideoId } from '../../helpers';

export const YOUTUBE_OEMBED_URL =
  'https://www.youtube.com/oembed?format=json&url=https%3A//youtube.com/watch%3Fv%3D';

export const setVideoMeta = (
  session: Session,
  setSession: Dispatch<SetStateAction<Session>>
): void => {
  axios
    .get(`${YOUTUBE_OEMBED_URL}${getVideoId(session.song.source)}`)
    .then((result) =>
      setSession({
        ...session,
        song: {
          ...session.song,
          title: result.data?.title,
          artist: result.data?.author_name,
        },
      })
    );
};
